import Badge, { Primary, New } from './Badge'

Badge.Primary = Primary
Badge.New = New

export default Badge

export { Primary, New }
